
import { useBankInterfaceMonitoringMaintenanceTracked } from "presentation/store/BankInterfaceMonitoring/BankInterfaceMonitoringMaintenanceProvider";
import { memo } from "react";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import BankInterfaceMonitoringTablePanel from "./BankInterfaceMonitoringTablePanel";
import BankInterfaceMonitoringMainFormPanel from "./RightPanel/BankInterfaceMonitoringMainFormPanel";

const BankInterfaceMonitoringRightPanel: React.FC = () => {
    const [bankInterfaceMonitoringState] = useBankInterfaceMonitoringMaintenanceTracked();
    const { isShowRightPanel } = bankInterfaceMonitoringState;

    return <>
        <div className={`main-comp-wrapper${isShowRightPanel ? '' : ' im-hide-side-form-draggable'}`}>
            {
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={isShowRightPanel ? "45%" : "100%"}
                    rightSectionWidth={isShowRightPanel ? "55%" : "0%"}
                    leftChildren={<BankInterfaceMonitoringTablePanel />}
                    rightChildren={<BankInterfaceMonitoringMainFormPanel />}
                />
            }
        </div>
    </>
}

export default memo(BankInterfaceMonitoringRightPanel);